import commentIconSvg from '@harbour-enterprises/common/icons/comment-solid.svg?raw';
import caretDownIconSvg from '@harbour-enterprises/common/icons/caret-down-solid.svg?raw';
import userCheckIconSvg from '@harbour-enterprises/common/icons/user-check-solid.svg?raw';
import usersIconSvg from '@harbour-enterprises/common/icons/users-solid.svg?raw';
import checkIconSvg from '@harbour-enterprises/common/icons/check-solid.svg?raw';
import xmarkIconSvg from '@harbour-enterprises/common/icons/xmark-solid.svg?raw';
import ellipsisVerticalSvg from '@harbour-enterprises/common/icons/ellipsis-vertical-solid.svg?raw';

export const superdocIcons = {
  comment: commentIconSvg,
  caretDown: caretDownIconSvg,
  internal: userCheckIconSvg,
  external: usersIconSvg,
  markDone: checkIconSvg,
  acceptChange: checkIconSvg,
  rejectChange: xmarkIconSvg,
  overflow: ellipsisVerticalSvg,
};
